import React, { useState, useEffect } from 'react';
import { Widget, GridView, SimpleView } from '@digital/ui';
import { ReportCapexManeger, getAllRequisitadoAno } from '../../api/relatorios';
import CapexManagement from './capexManagement';
import CapexManagementSumary from './capexManagementSumary';
import CapexManagementGrafico from './capexManagementGrafico';


const Graficos = () => {
    const [relatorio, setRelatorio] = useState<ReportCapexManeger>();
    useEffect(() => {
        getAllRequisitadoAno().then((data) => {
            if (data) {
                setRelatorio(data);
            }
        });
    }, [])

    return (
        <SimpleView >
            <GridView noform>
                <Widget
                    title="RESULTADO"
                    span={12}
                    actions={[]}>
                    {relatorio ? <CapexManagementSumary data={relatorio} /> : <></>}
                    {relatorio ? <CapexManagement data={relatorio} /> : <></>}
                    {relatorio ? <CapexManagementGrafico data={relatorio} /> : <></>}
                </Widget>
            </GridView>
        </SimpleView>
    );
};

export default Graficos;
